import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import HeaderBackground from "../../../common/SubpagesBGimage";
import SideNavigation from "../../Menu-sidenavbar/SideNavigation ";
import Footer from "../../Layout/Footer";
import Header from "../../Layout/Header";
import { StatutoryCommitteeActions } from "../../../Store/Statutory Committee/action";

function StudentsGrievanceCommittee() {
  const location = useLocation();
  const { committeeSlug } = useParams();
  const dispatch = useDispatch();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  document.title = "Students Grievance Committee | PSG-IAP"
  const routeNames = {
    "/statutory-committee": {
      menuName: "About Us",
      subMenuName: "Statutory Committee",
    },
  };

  const { menuName = "About Us", subMenuName = "Statutory Committee" } =
    location.state || routeNames[location.pathname] || {};

  const { StatutoryCommitteeSubpage } = useSelector(
    (state) => state?.StatutoryCommitteeReducer
  );

 useEffect(() => {
  if (!StatutoryCommitteeSubpage || StatutoryCommitteeSubpage.length === 0) {
    dispatch({
      type: StatutoryCommitteeActions.GET_STATUTORY_COMMITTEE_SUBPAGE,
    });
  }
}, [dispatch, StatutoryCommitteeSubpage]);


  // Robust slugify to handle curly quotes, special chars
  const slugify = (text) => {
    if (!text) return "";
    return text
      .toLowerCase()
      .replace(/’/g, "")        // remove curly apostrophe
      .replace(/['"`]/g, "")    // remove straight quotes
      .replace(/[^\w\s-]/g, "") // remove other special characters
      .replace(/\s+/g, "-");    // spaces to dash
  };

  // Find the selected committee safely
  const selectedCommittee = StatutoryCommitteeSubpage?.find(
    (committee) => slugify(committee.committee_name) === committeeSlug
  );

  // Fallback: if slug matching fails, try exact match by name
  const finalCommittee = selectedCommittee || StatutoryCommitteeSubpage?.find(
    (committee) =>
      committee.committee_name === "Student’s Grievance and Redressal Committee"
  );
  const chairman = finalCommittee?.statutory_chairman?.[0];
  const departments = finalCommittee?.departments || [];

  return (
    <div>
      <HeaderBackground
        menuName={menuName}
        subMenuName={subMenuName}
        thirdLevelName="Students Grievance Committee"
        handleMenuToggle={() => setIsMenuOpen(!isMenuOpen)}
      />
      <Header />

      <div className="statutory">
        <div className="container committee-container">
          {/* Committee Title */}
          <h6 className="rectangle-title">
            <span className="rectangle-marker"></span>
            {finalCommittee?.committee_name || "Committee"}
          </h6>
          <hr />

          {/* Optional content */}
          {finalCommittee?.content && (
            <p className="committee-content mb-4">{finalCommittee.content}</p>
          )}

          {/* Chairman */}
          {chairman && (
            <div className="mb-5">
              <h5 className="mt-4 text-start subb-title">Chairman</h5>
              <div className="committee-info d-flex align-items-start">
                <div className="col-md-4 mb-3 committee-image">
                  <img
                    src={chairman.image || "/placeholder.jpg"}
                    alt={chairman.name}
                    className="img-fluid rounded shadow img-thumbnail1"
                  />
                </div>
                <div className="committee-content text-left">
                  <p className="committee-name">{chairman.name}</p>
                  <p className="committee-position">{chairman.designation}</p>
                  <p className="committee-text mb-1">{chairman.address}</p>
                  <p className="committee-text mb-1">{chairman.city}</p>
                  {chairman.phone && (
                    <p className="committee-text mb-1">
                      <span className="label-blue">Phone:</span>{" "}
                      <span className="value-grey">{chairman.phone}</span>
                    </p>
                  )}
                  {chairman.email && (
                    <p className="committee-text mb-1">
                      <span className="label-blue">E-mail:</span>{" "}
                      <span className="value-grey">{chairman.email}</span>
                    </p>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* Departments and Members */}
          {departments.map((dept, deptIdx) => (
            <div key={deptIdx} className="mb-5">
              <h5 className="mt-4 text-start subb-title">{dept.department_name}</h5>
              <div className="row mt-3">
                {dept.members.map((member, idx) => (
                   <div className="col-12 col-sm-6 col-lg-4 mb-4" key={idx}>
                    <div className="card member-card text-left p-4 shadow-sm">
                      <h5 className="member-name">{member.member_name}</h5>
                      {member.designation && <p className="member-title">{member.designation}</p>}
                      {member.committee && <p className="member-title">{member.committee}</p>}
                      {member.phone && (
                        <p className="member-text">
                          <span className="label-blue">Mobile No:</span>{" "}
                          <span className="value-grey">{member.phone}</span>
                        </p>
                      )}
                      {member.email && (
                        <p className="member-text">
                          <span className="label-blue">E-mail:</span>{" "}
                          <span className="value-grey">{member.email}</span>
                        </p>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      <SideNavigation
        key="About Us"
        isMenuOpen={isMenuOpen}
        handleMenuToggle={() => setIsMenuOpen(!isMenuOpen)}
        defaultOpenSubMenu="About Us"
      />
      <Footer />
    </div>
  );
}

export default StudentsGrievanceCommittee;



